import React from "react";
import { Html } from "@react-three/drei";

export default function DimensionPointMarker({
  point,
  index = 0,
  markerSize = 1.5,
}) {
  if (!point?.world) return null;

  const p = point.world;

  const color =
    index === 0 ? "#ef4444" : index === 1 ? "#f97316" : "#2563eb";

  return (
    <group position={[p.x, p.y, p.z]}>
      <mesh renderOrder={40}>
        <sphereGeometry args={[markerSize, 16, 16]} />
        <meshBasicMaterial color={color} depthTest={false} />
      </mesh>

      <Html center distanceFactor={6} style={{ pointerEvents: "none" }}>
        <div
          style={{
            minWidth: 20,
            height: 20,
            borderRadius: 999,
            background: "white",
            border: "1px solid #cbd5e1",
            fontSize: 13,
            lineHeight: "18px",
            textAlign: "center",
            fontWeight: 800,
            color: "#0f172a",
            boxShadow: "0 1px 5px rgba(0,0,0,0.2)",
          }}
        >
          {index + 1}
        </div>
      </Html>
    </group>
  );
}